<script>
	export let sleepData = null;
	export let samsungCount = null;
</script>

{#if sleepData}
	<div class="card mb-4">
		<div class="card-header">
			<h5 class="card-title mb-0">
				<i class="bx bx-info-circle me-1"></i>
				세션 메타 정보
			</h5>
		</div>
		<div class="card-body">
			<div class="table-responsive">
				<table class="table table-bordered table-sm mb-0">
					<thead class="table-light">
						<tr>
							<th style="width:20%">항목</th>
							<th style="width:30%">값</th>
							<th style="width:20%">항목</th>
							<th style="width:30%">값</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="fw-medium">리전</td>
							<td>{sleepData.region || '-'}</td>
							<td class="fw-medium">앱 패키지명</td>
							<td><code>{sleepData.packageName || '-'}</code></td>
						</tr>
						<tr>
							<td class="fw-medium">앱 버전</td>
							<td>
								{#if sleepData.appVersion}
									{sleepData.appVersion}
									{#if sleepData.appVersionCode}
										<span class="text-muted">({sleepData.appVersionCode})</span>
									{/if}
								{:else}
									-
								{/if}
							</td>
							<td class="fw-medium">Dart 버전</td>
							<td>{sleepData.dartVersion || '-'}</td>
						</tr>
						<tr>
							<td class="fw-medium">알고리즘 버전</td>
							<td>
								{#if sleepData.algorithmVersion}
									<span class="badge bg-label-primary">{sleepData.algorithmVersion}</span>
								{:else}
									-
								{/if}
							</td>
							<td class="fw-medium">Samsung 데이터 수</td>
							<td>{samsungCount !== null ? samsungCount + '건' : '-'}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
{/if}
